/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
.scale--s {
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
  --calcite-combobox-item-spacing-unit-l: 0.5rem;
  --calcite-combobox-item-spacing-unit-s: 0.25rem;
  --calcite-combobox-item-spacing-indent: 0.5rem;
}

.scale--m {
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
  --calcite-combobox-item-spacing-unit-l: 0.75rem;
  --calcite-combobox-item-spacing-unit-s: 0.5rem;
  --calcite-combobox-item-spacing-indent: 0.75rem;
}

.scale--l {
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
  --calcite-combobox-item-spacing-unit-l: 1rem;
  --calcite-combobox-item-spacing-unit-s: 0.75rem;
  --calcite-combobox-item-spacing-indent: 1rem;
}

:host,
.list {
  margin: 0px;
  display: flex;
  flex-direction: column;
  padding: 0px;
}

:host(:focus),
.list:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.label {
  box-sizing: border-box;
  display: flex;
  inline-size: 100%;
  min-inline-size: 0px;
  max-inline-size: 100%;
  color: var(--calcite-color-text-3);
}

.title {
  --calcite-combobox-item-indent-value: calc(
    var(--calcite-combobox-item-spacing-indent) * var(--calcite-combobox-item-spacing-indent-multiplier)
  );
  border: 0 solid;
  display: block;
  flex: 1 1 0%;
  border-block-end-width: 1px;
  font-weight: var(--calcite-font-weight-bold);
  color: var(--calcite-color-text-2);
  word-wrap: break-word;
  word-break: break-word;
  border-block-end-color: var(--calcite-color-border-3);
  padding-block: var(--calcite-combobox-item-spacing-unit-l);
  padding-inline: var(--calcite-combobox-item-spacing-unit-s);
  margin-inline-start: var(--calcite-combobox-item-indent-value);
}

::slotted(calcite-combobox-item-group:not([after-empty-group])) {
  padding-block-start: var(--calcite-combobox-item-spacing-unit-l);
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}